<template>
  <van-loading size="24px" vertical class="loading">
    {{ $t("loading") }}...
  </van-loading>
</template>

<script>
export default {
  name: "Loading"
};
</script>
